/** Error returned by the API: stable `code` + optional details (translated by the UI). */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    public readonly details: Record<string, unknown> = {},
  ) {
    super(code);
  }
  get fields(): Record<string, string> {
    return (this.details.fields as Record<string, string>) ?? {};
  }
}

export class NetworkError extends Error {}

type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

/**
 * JSON fetch against the same-origin API. Authentication relies on the
 * httpOnly session cookie set by the server — the app never sees the token.
 */
export async function api<T = unknown>(path: string, options: { method?: Method; body?: unknown } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: options.method ?? "GET",
      credentials: "same-origin",
      headers: options.body !== undefined ? { "Content-Type": "application/json" } : undefined,
      body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
    });
  } catch {
    throw new NetworkError("network");
  }
  const data = res.status === 204 ? null : await res.json().catch(() => null);
  if (!res.ok) {
    const { code = "INTERNAL_ERROR", ...details } = (data?.error ?? {}) as { code?: string } & Record<string, unknown>;
    throw new ApiError(res.status, code, details);
  }
  return data as T;
}
